import {useSuspenseQuery} from '@tanstack/react-query';
import {injectAlphabeticalSort, prepareSearchParams} from 'shared';

import {api} from '@/lib/ky';
import {extractPagination} from '@/utils/extractPagination';

import {layoutTemplateListSchema} from '../utils/schemas/layout';

import {layoutTemplateKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getLayoutTemplates = async (params: QueryParams = {}) => {
  const res = await api.get(`layouts`, {
    searchParams: prepareSearchParams(injectAlphabeticalSort(params)),
  });
  const data = await res.json();
  const pagination = extractPagination(res);

  return [layoutTemplateListSchema.parse(data), pagination] as const;
};

export const useLayoutTemplates = (
  params?: QueryParams,
  config?: QueryConfig<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: layoutTemplateKeys.list(params),
    queryFn: () => getLayoutTemplates(params),
  });
};
export const useLayoutTemplatesLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getLayoutTemplates;
type QueryParams = Parameters<typeof layoutTemplateKeys.list>[0];
